<template>
    <v-container class="pb-6">
        <Form
            :plan="this.plan"
            @saved="saved"
            :titlePrefix="$t('form.actions.edit')"
            :isEdit="true"
            v-if="this.plan"
        ></Form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import Plan from '@/models/plans/Plan'
import Form from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            plan: null,
        }
    },

    components: {
        Form,
    },

    methods: {
        async getPlan() {
            let item = await this.model.find(this.id)

            this.plan = item
        },

        saved() {
            this.$router.push({ name: 'plans.index' })
        },
    },

    computed: {
        model() {
            return new Plan()
        },
    },

    created() {
        this.getPlan()
    },
}
</script>
